import moment from "moment";
import ActionColumnComponent from "../../../disaster/components/ActionColumn/ActionColumn";

export const getAllColumns = (viewModal, updateModal, deleteRecord) => {
  const actionColumn = ActionColumnComponent({
    viewModal,
    updateModal,
    deleteRecord,
  });

  return {
    "Marriage Certificate Divorce": [
      {
        title: "Document Name",
        dataIndex: "Document Name",
        key: "documentName",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Who's Document",
        dataIndex: "Who's Document ",
        key: "whodocument",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Expiration Date",
        dataIndex: "Expiration Date",
        key: "expirationDate",
        render: (record) => (record ? moment(record).format("MM/DD/YYYY") : "N/A"),
      },
      actionColumn,
    ],
 
    "Prenuptial Agreement Divorce": [
        {
            title: "Document Name",
            dataIndex: "Document Name",
            key: "documentName",
            render: (record) => (record ? record : "N/A"),
          },
          {
            title: "Who's Document",
            dataIndex: "Who's Document ",
            key: "whodocument",
            render: (record) => (record ? record : "N/A"),
          },
          {
            title: "Expiration Date",
            dataIndex: "Expiration Date",
            key: "expirationDate",
            render: (record) => (record ? moment(record).format("MM/DD/YYYY") : "N/A"),
          },
      actionColumn,
    ],
    "Postnuptial Agreement Divorce": [
        {
            title: "Document Name",
            dataIndex: "Document Name",
            key: "documentName",
            render: (record) => (record ? record : "N/A"),
          },
          {
            title: "Who's Document",
            dataIndex: "Who's Document ",
            key: "whodocument",
            render: (record) => (record ? record : "N/A"),
          },
          {
            title: "Expiration Date",
            dataIndex: "Expiration Date",
            key: "expirationDate",
            render: (record) => (record ? moment(record).format("MM/DD/YYYY") : "N/A"),
          },
      actionColumn,
    ],
    "Previous Divorce Decrees Divorce": [
        {
            title: "Document Name",
            dataIndex: "Document Name",
            key: "documentName",
            render: (record) => (record ? record : "N/A"),
          },
          {
            title: "Who's Document",
            dataIndex: "Who's Document ",
            key: "whodocument",
            render: (record) => (record ? record : "N/A"),
          },
          {
            title: "Expiration Date",
            dataIndex: "Expiration Date",
            key: "expirationDate",
            render: (record) => (record ? moment(record).format("MM/DD/YYYY") : "N/A"),
          },
      actionColumn,
    ],
    "Living Will Divorce": [
      {
          title: "Document Name",
          dataIndex: "Document Name",
          key: "documentName",
          render: (record) => (record ? record : "N/A"),
        },
        {
          title: "Who's Document",
          dataIndex: "Who's Document ",
          key: "whodocument",
          render: (record) => (record ? record : "N/A"),
        },
        {
          title: "Expiration Date",
          dataIndex: "Expiration Date",
          key: "expirationDate",
          render: (record) => (record ? moment(record).format("MM/DD/YYYY") : "N/A"),
        },
    actionColumn,
  ],
  "Living Trust Divorce": [
    {
        title: "Document Name",
        dataIndex: "Document Name",
        key: "documentName",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Who's Document",
        dataIndex: "Who's Document ",
        key: "whodocument",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Expiration Date",
        dataIndex: "Expiration Date",
        key: "expirationDate",
        render: (record) => (record ? moment(record).format("MM/DD/YYYY") : "N/A"),
      },
  actionColumn,
],
"Power Of Attorney Divorce": [
  {
      title: "Document Name",
      dataIndex: "Document Name",
      key: "documentName",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Who's Document",
      dataIndex: "Who's Document ",
      key: "whodocument",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Expiration Date",
      dataIndex: "Expiration Date",
      key: "expirationDate",
      render: (record) => (record ? moment(record).format("MM/DD/YYYY") : "N/A"),
    },
actionColumn,
],
"Healthcare Directives Divorce": [
  {
      title: "Document Name",
      dataIndex: "Document Name",
      key: "documentName",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Who's Document",
      dataIndex: "Who's Document ",
      key: "whodocument",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Expiration Date",
      dataIndex: "Expiration Date",
      key: "expirationDate",
      render: (record) => (record ? moment(record).format("MM/DD/YYYY") : "N/A"),
    },
actionColumn,
],
"Business Agreements Divorce": [
  {
      title: "Document Name",
      dataIndex: "Document Name",
      key: "documentName",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Who's Document",
      dataIndex: "Who's Document ",
      key: "whodocument",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Expiration Date",
      dataIndex: "Expiration Date",
      key: "expirationDate",
      render: (record) => (record ? moment(record).format("MM/DD/YYYY") : "N/A"),
    },
actionColumn,
],
"Court Orders Divorce": [
  {
      title: "Document Name",
      dataIndex: "Document Name",
      key: "documentName",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Who's Document",
      dataIndex: "Who's Document ",
      key: "whodocument",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Expiration Date",
      dataIndex: "Expiration Date",
      key: "expirationDate",
      render: (record) => (record ? moment(record).format("MM/DD/YYYY") : "N/A"),
    },
actionColumn,
],
  };
};
